let url = (new URL(document.URL));
let host = url.hostname
export const domain = host.replace('cpanel.', '')
export const teste = ""

export const rootUrl = 'https://api.'+domain+'/'
export const apiUrl = 'https://api.'+domain+'/cpanel/'
export const SCROLL = 200
export const auth_id = 3
export const auth_secret = '7zwB4hGme84QR7DHvgUT3zC9ZW3G86JsBijxCHJy'

export const banks = 
{
    pay2m: {
        register: 'https://wa.me/5511945966869',
        playstore: 'https://play.google.com/store/apps/details?id=br.com.pay2m.client',
        apple_store: 'https://apps.apple.com/br/app/pay2m/id6743003137'
    },
    fluxsis: {
        register: 'https://wa.me/5547988604220',
        playstore: 'https://play.google.com/store/apps/details?id=br.com.infopago',
        apple_store: 'https://apps.apple.com/br/app/fluxsis-infopago/id1660584431'
    },
    codepay: {
        register: 'https://www.codepay.one/auth/register-account',
        playstore: 'https://play.google.com/store/apps/details?id=br.com.app.gpu3203951.gpu6e2092adf15ed6c2459410e671e23b5d',
        apple_store: 'https://apps.apple.com/br/app/codepay-one/id6742108364'
    },
    efipay: {
        register: 'https://sejaefi.com.br',
        playstore: 'https://play.google.com/store/apps/details?id=br.com.gerencianet.app',
        apple_store: 'https://apps.apple.com/br/app/ef%C3%AD-bank-conta-digital/id1443363326'
    },
    ezzy: {
        register: 'https://app.ezzybanking.com.br/login',
        playstore: null,
        apple_store: null,
        whatsapp: 'https://wa.me/558000003096'
    },
    suitpay: {
        register: 'https://wa.me/5511916502160',
        playstore: 'https://play.google.com/store/apps/details?id=com.suitpay',
        apple_store: 'https://apps.apple.com/br/app/suitpay/id1632130123'
    },
    mercadopago: {
        register: 'https://www.mercadopago.com.br',
        playstore: 'https://play.google.com/store/apps/details?id=com.mercadopago.wallet',
        apple_store: 'https://apps.apple.com/br/app/mercado-pago-banco-digital/id925436649'
    },
    paggue: {
        register: 'https://paggue.io',
        playstore: 'https://play.google.com/store/apps/details?id=com.paggueclientapp',
        apple_store: 'https://apps.apple.com/us/app/paggue/id1542988650'
    }
}